import { DataModel } from 'legacy/lut/classes/models/DataModel'
import React from 'react'

import { IForm } from 'core-components/classes/models/IForm'
import { Grid, Item } from 'core-components/library/grid'
import { Loader } from 'core-components/library/loader'
import { getFormatDate } from 'core/classes/helpers/DateHelper'

import styles from '../ContactTileCell.module.scss'

import RenderCardHead from './RenderCardHead'
import { renderCardStatusLine } from './tileBlocksMethods'

export default function registrationBlock(
  item: DataModel | IForm,
  isLoading: boolean,
  registration?: IObjectAny
) {
  const { Date = '', Status = '-', EnrollmentId = '-' } = registration || {}

  if (isLoading) {
    return <Loader />
  }

  return (
    <Grid className={styles.dataGrid} wrap={'nowrap'}>
      <Item xs={'auto'}>{renderCardStatusLine(item)}</Item>
      <Item xs={'auto'}>
        <span className={`kbase kbase-document ${styles.dataIcon}`} />
      </Item>
      <Item xs={true}>
        <p className={styles.data}>
          <span className={styles.data__label}>Date:</span>
          <span className={styles.data__value}>{getFormatDate(Date, 'date')}</span>
        </p>
        <p className={styles.data}>
          <span className={styles.data__label}>Status:</span>
          <span className={styles.data__value}>{Status}</span>
        </p>
        <p className={styles.data}>
          <span className={styles.data__label}>EnrollmentId:</span>
          <span className={styles.data__value}>{EnrollmentId}</span>
        </p>
      </Item>
      <Item xs={'auto'}>
        <RenderCardHead item={item} />
      </Item>
    </Grid>
  )
}
